import React from 'react'
import PropTypes from 'prop-types'
import DailyGreetingWealthJourney from './DailyGreetingWealthJourney'
import DailyGreetingRedtail from './DailyGreetingRedtail'
import DailyGreetingNoOverdue from './DailyGreetingNoOverdue'

// Runtime routing (resolvedTasksSource): defaultProps.tasksSource is 'wealthJourney' so omitted props match PropTypes and behave as before. Explicit null, PropTypes-invalid strings, or any value other than 'wealthJourney' | 'redtail' → DailyGreetingNoOverdue (no overdue fetch, no overdue phrase). Dev may warn for unknown strings even though behavior is defined.
const DailyGreeting = ({
  userName,
  meetingsLinkTo,
  tasksLinkTo,
  overdueStartDate,
  tasksSource: tasksSourceProp,
  tasksLinkMode: tasksLinkModeProp,
  blueprintCode,
  meetingsPresentationKey,
  tasksPresentationKey
}) => {
  const resolvedTasksSource = tasksSourceProp === undefined ? 'wealthJourney' : tasksSourceProp
  const tasksLinkMode = tasksLinkModeProp === undefined ? 'route' : tasksLinkModeProp

  const common = {
    userName,
    meetingsLinkTo,
    tasksLinkTo,
    overdueStartDate,
    tasksLinkMode
  }

  if (resolvedTasksSource === 'wealthJourney') {
    return <DailyGreetingWealthJourney {...common} />
  }
  if (resolvedTasksSource === 'redtail') {
    return (
      <DailyGreetingRedtail
        {...common}
        blueprintCode={blueprintCode}
        meetingsPresentationKey={meetingsPresentationKey}
        tasksPresentationKey={tasksPresentationKey}
      />
    )
  }
  return <DailyGreetingNoOverdue {...common} />
}

DailyGreeting.propTypes = {
  userName: PropTypes.string,
  meetingsLinkTo: PropTypes.string,
  tasksLinkTo: PropTypes.string,
  overdueStartDate: PropTypes.string,
  tasksSource: PropTypes.oneOf(['wealthJourney', 'redtail', null]),
  tasksLinkMode: PropTypes.oneOf(['route', 'overlay']),
  blueprintCode: PropTypes.string,
  meetingsPresentationKey: PropTypes.string,
  tasksPresentationKey: PropTypes.string
}

DailyGreeting.defaultProps = {
  userName: undefined,
  meetingsLinkTo: 'meetings-overview',
  tasksLinkTo: 'tasks-overview',
  overdueStartDate: '$prevYearStart',
  tasksSource: 'wealthJourney',
  tasksLinkMode: undefined,
  blueprintCode: undefined,
  meetingsPresentationKey: undefined,
  tasksPresentationKey: undefined
}

export default DailyGreeting
